import React from 'react';
import PropTypes from 'prop-types';

const RowHead = ({ title, beneficiary, children }) => (
  <div className="flex-row padding-bottom-5">
    <div style={{ flexDirection: 'column' }} className="flex-grid-first flex-grid-center-horizontal">
      <div className="style-text-title"> {title} </div>
      <div className="text-weight"> {beneficiary} </div>
    </div>
    {children}
  </div>
);

RowHead.propTypes = {
  title: PropTypes.string,
  beneficiary: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

RowHead.defaultProps = {
  title: '',
  beneficiary: '',
};

export default RowHead;
